import store from '@/store/index'
import { Message } from 'element-ui';

export default async function (to, from, next) {
  console.log('route middleware: check login status. to=', to)
  let old_account_info = store.state.account.account_info
  await store.dispatch('account/action_get_personal_info')
  let new_account_info = store.state.account.account_info

  if (typeof old_account_info !== 'undefined' && 
      typeof old_account_info['id'] !== 'undefined' && 
      typeof new_account_info !== 'undefined' && 
      typeof new_account_info['id'] !== 'undefined' && 
      old_account_info['id'] !== new_account_info['id']
    ) {
    window.location.reload()
  }

  let is_login = store.state.account.is_login
  console.log('route middleware: check login status. is_login=', is_login)
  if (!is_login && to.name !== 'login' && to.name !== 'reset' && to.fullPath.startsWith("/backstage")) {
    Message.warning({message: '請重新登入'})
    next({ path: '/backstage/login' })
  } else {
    next()
  }
}
